import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// components
import BatchParticipant from './../../components/BatchParticipant/BatchParticipant';
import { BatchContext, BatchPartContext, CommonContext } from './../../contexts/constant/ActionTypes';

const BatchParticipantPage = ({history, match}) => {
    const batchContext = useContext(BatchContext);
	const batchPartContext = useContext(BatchPartContext);
    const commonContext = useContext(CommonContext);
	// const userContext = useContext(UserContext);
	
	return (
		<BatchParticipant
			history={history}
			match={match}
			batchContext={batchContext}
			batchPartContext={batchPartContext}
            commonContext={commonContext}
			// userContext={userContext}
		/>
	);
}

BatchParticipantPage.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

BatchParticipantPage.defaultProps = {
    history: {},
    match: {}
};

export default BatchParticipantPage;



// WEBPACK FOOTER //
// ./containers/BatchParticipantPage/BatchParticipantPage.js